import { ModalHeader } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { ModalHeaderProps } from '../../lib/types';

const { Container, Subtitle, Title } = ModalHeader;

export const ModalHeaderSecondary = ({
  title,
  maxLinesSubtitle,
  maxLinesTitle,
  subtitle,
  ...props
}: ModalHeaderProps) => (
  <Container {...props}>
    <Stack gap={4}>
      <Title maxLines={maxLinesTitle} mr={40} variant="title-3-md">
        {title}
      </Title>
      {subtitle && (
        <Subtitle color="grey.700" maxLines={maxLinesSubtitle} variant="body-2">
          {subtitle}
        </Subtitle>
      )}
    </Stack>
  </Container>
);
